module.exports = __webpack_public_path__ + "media/images/signup-and-read-kv-3rd-a1b25ca650ceb17d625ca2d0c7e005e5.png";